import { useAuth } from '../contexts/AuthContext'
import { Sparkles, ShieldCheck, Menu } from 'lucide-react'

const Header = ({ onToggleSidebar }) => {
  const { user } = useAuth()

  const getGreeting = () => {
    const hour = new Date().getHours()
    if (hour < 12) return 'sáng'
    if (hour < 18) return 'chiều'
    return 'tối'
  }

  return (
    <header className="sticky top-0 z-20 border-b border-white/60 bg-[#f8fbf8]/90 backdrop-blur-xl">
      <div className="flex w-full items-center justify-between px-4 py-5 md:px-6">
        <div className="flex items-center gap-3">
          <button
            onClick={onToggleSidebar}
            className="hidden h-11 w-11 items-center justify-center rounded-2xl border border-slate-200 bg-white text-slate-600 shadow-sm transition hover:border-slate-300 hover:bg-slate-50 hover:text-slate-900 lg:inline-flex"
            type="button"
          >
            <Menu className="h-5 w-5" />
          </button>
          <h2 className="font-display text-2xl font-bold tracking-tight text-slate-900">
            Chào bảo bối buổi {getGreeting()}, {user?.name?.split(' ')[0] || 'User'} 👋 
          </h2>
        </div>

        <div className="flex items-center gap-3">

          <div className="flex items-center gap-3 rounded-2xl border border-white/70 bg-white/90 px-3 py-2 shadow-sm">
            <div className="flex h-10 w-10 items-center justify-center rounded-2xl bg-primary-50 text-primary-700">
              <ShieldCheck className="w-4 h-4" />
            </div>
            <div className="hidden text-sm md:block">
              <p className="font-semibold text-slate-900">{user?.name}</p>
              <p className="text-slate-500">{user?.email}</p>
            </div>
          </div>
        </div>
      </div>
    </header>
  )
}

export default Header
